export default "__VITE_ASSET__vZdFz_Jw__"